window.jQuery = require('jquery');

// FitVids
require('./vendor/jquery.fitvids');
require('./vendor/jquery.tablesorter');
require('./vendor/jquery-accessible-accordion-aria');
require('./vendor/chosen.jquery');
require('./vendor/stacktable');
require('select2');

require('./framework');
require('./window-width');

require('./site/modal');
require('./site/selection-buttons');
require('./site/list-search-expand');
require('./site/main-nav');
require('./site/conditional-questions');
require('./site/repeating-questions');
require('./site/form-validation');
require('./site/navigation-warning');
require('./site/deletion-confirmation');
require('./site/confirmation-dialog');
require('./site/page-totals');
require('./site/fit-text');
require('./site/snippets');
require('./site/file-upload-questions');

require('./init');
